import React from 'react';
import { Col } from '../../../lib/utils';
import SvgIcon from '../../../components/SvgIcon';

type Props = {
    /** 아이콘 크기 */
    iconSize?: number;
    /** 아이콘 색상 */
    iconFill?: string;
    /** 아이콘 클래스 */
    iconClassName?: string;

    // 원크기
    width?: number;
    height?: number;
    mr?: number;
};

const FeedCenterStatisticsReregister = ({
    iconSize = 32,
    iconFill = '#427BE8',
    iconClassName = '',
    width = 64,
    height = 64,
    mr = 12,
}: Props) => {
    return (
        <Col
            style={{
                width: `${width}px`,
                height: `${height}px`,
            }}
            className={`justify-center items-center border-[0.25px] border-solid border-[#A32BFF26] rounded-[50px] bg-[#F6EAFF] mr-[${mr}px]`}
        >
            <SvgIcon name="SvgCenterStatisticsReregister" size={iconSize} fill={iconFill} className={iconClassName} />
        </Col>
    );
};

export default FeedCenterStatisticsReregister;
